import { useState } from 'react'
import { IconMoon, IconSun, IconSystem } from '../icons.js'
import type { ThemeChoice, ThemeStore } from './theme.js'

export interface ThemeToggleProps {
  store: ThemeStore
}

/**
 * Три положения, а не выключатель «светлая/тёмная»: без «системной» тема
 * портала перестала бы следовать за настройкой рабочего места, и человек,
 * у которого система сама темнеет к вечеру, получал бы светящийся экран.
 */
const OPTIONS: readonly { choice: ThemeChoice; label: string; Icon: typeof IconSun }[] = [
  { choice: 'system', label: 'Тема как в системе', Icon: IconSystem },
  { choice: 'light', label: 'Светлая тема', Icon: IconSun },
  { choice: 'dark', label: 'Тёмная тема', Icon: IconMoon },
]

/**
 * Переключатель темы в подвале боковой навигации — рядом с почтой вошедшего
 * и выходом. Это настройка рабочего места, а не страницы: в шапке раздела
 * она соседствовала бы с действиями над данными и читалась как одно из них.
 *
 * Значками без подписей: три слова заняли бы всю ширину свёрнутой навигации,
 * а сами положения человек узнаёт по солнцу и луне быстрее, чем прочитает.
 * Подписи при этом никуда не делись — они в `aria-label` и всплывающей
 * подсказке, то есть доступны и программе чтения с экрана, и мыши.
 */
export function ThemeToggle(props: ThemeToggleProps) {
  const { store } = props
  // Хранилище — источник правды, состояние здесь только чтобы перерисовать
  // отметку: сам выбор уже применён к документу атрибутом.
  const [choice, setChoice] = useState<ThemeChoice>(() => store.choice())

  return (
    <div className="тема" role="group" aria-label="Оформление портала">
      {OPTIONS.map((option) => (
        <button
          key={option.choice}
          type="button"
          className="тема__кнопка"
          aria-label={option.label}
          title={option.label}
          aria-pressed={choice === option.choice}
          onClick={() => {
            store.set(option.choice)
            setChoice(option.choice)
          }}
        >
          <option.Icon />
        </button>
      ))}
    </div>
  )
}
